import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ButtonComponent } from '../button/button.component';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';

/**
 * Database reset confirmation dialog
 * Shows when backend database generation differs from local database
 * (e.g., after running env:sync script to copy production/integration data)
 *
 * User options:
 * - Reset & Re-sync: Delete local database and download fresh copy from backend
 * - Keep Local Data: Continue with local data (may cause sync conflicts)
 */
@Component({
  selector: 'app-database-reset-dialog',
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent, TranslatePipe],
  templateUrl: './database-reset-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './database-reset-dialog.component.css',
})
export class DatabaseResetDialogComponent {
  @Output() reset = new EventEmitter<boolean>();

  onReset(): void {
    this.reset.emit(true);
  }

  onKeepLocal(): void {
    this.reset.emit(false);
  }
}
